import { Pipe, PipeTransform } from '@angular/core';
import { IVenueModel } from '@shared/models/venue.model';
import { IEventLocationDateTimeStatus } from '@shared/services/api/legacy/events-service/event-model';

@Pipe({
  name: 'venueStatus'
})
export class VenueStatusPipe implements PipeTransform {

  public transform(eventLocationDateTime: IEventLocationDateTimeStatus[], locationDateTime: IVenueModel): IEventLocationDateTimeStatus {
    let status: IEventLocationDateTimeStatus  = null;
    if (locationDateTime && eventLocationDateTime.find(x => x.id === locationDateTime.id)) {
      status = eventLocationDateTime.find(x => x.id === locationDateTime.id);
    }

    if (!status) {
      status = {
        id: null,
        totalRegistered: 0,
        totalCheckedIn: 0,
        totalCheckedOut: 0,
        totalNoShow: 0,
        status: null
      };
    }

    return status;
  }

}
